module.exports = "<span ng-click=\"ctrl.help()\" class=\"label label-info preview-label\"><i class=\"fas fa-flask\"></i>\r\n  {{'PREVIEW'|translate}}</span>"